import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import { toJalali } from "lib/helpers";
import ManageComment from "./ManageComment";
import useCanAccess from "hooks/useCanAccess";

export default function Comments() {
  const path = {
    baseRoute: "/comment-panel",
    aliasName: "نظرات",
    type: "Comment",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    customRequest,
    update,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();

  const [showManage, setShowManage] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [item, setItem] = useState(false);

  const can = useCanAccess();

  useEffect(() => {
    dispatch(getList(path));

    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      <ManageComment
        load={load}
        item={item}
        show={showManage}
        title="نمایش نظر"
        msg=""
        delete={() => {
          dispatch(
            remove(path, list, item?.id, () => {
              dispatch(getList(path));
              setShowManage(false);
            })
          );
        }}
        accept={() => {
          dispatch(
            customRequest(
              "put",
              `${path.baseRoute}/${item?.id}`,
              { status: true },
              () => {
                dispatch(getList(path));
                setShowManage(false);
              }
            )
          );
        }}
        reply={(content, cb) => {
          dispatch(
            customRequest(
              "post",
              `${path.baseRoute}`,
              {
                type: item?.type,
                refId: item?.refId?.id || item?.refId,
                replayTo: item?.id,
                isReplay: true,
                translations: {
                  fa: { content },
                  en: { content },
                },
              },
              () => {
                dispatch(getList(path));
                if (cb) cb();
              }
            )
          );
        }}
        close={() => {
          setShowManage(false);
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">نظرات</h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {from && `نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">کاربر</th>
                  <th className="whitespace-nowrap text-center">نظر</th>
                  <th className="whitespace-nowrap text-center">وضعیت</th>
                  <th className="whitespace-nowrap text-center">نوع</th>
                  <th className="whitespace-nowrap text-center"> تاریخ ثبت</th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list?.length > 0 &&
                  list?.map((item, index) => (
                    <tr key={`item_${index}`} className="intro-x">
                      <td>
                        <p className="font-medium text-center">
                          {item?.author &&
                            item?.author?.translations?.fa?.name +
                              " " +
                              item?.author?.translations?.fa?.lastName}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium text-center">
                          {item?.translations?.fa?.content
                            ? item?.translations?.fa?.content
                            : item?.translations?.en?.content}
                        </p>
                      </td>
                      <td className="text-center">
                        {" "}
                        {item?.status === true
                          ? "تایید شده"
                          : "در انتظار بررسی"}
                      </td>

                      <td className="text-center"> {item?.type}</td>
                      <td className="text-center">
                        {" "}
                        {toJalali(item?.createdAt, "HH:mm:ss jYYYY/jM/jD")}
                      </td>
                      <td className="table-report__action w-56">
                        <div className="flex justify-center items-center">
                          <a
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowManage(true);
                            }}
                          >
                            {" "}
                            <Icons.Eye className="w-4 h-4 ml-1" /> مدیریت{" "}
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
